if (!customElements.get('jky-v5-scroll-pic-3')) {
  class JkyV5ScrollPic3 extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      const slide1 = this.querySelector('.v5-scroll-pic-slide-1')
      const slide2 = this.querySelector('.v5-scroll-pic-slide-2')
      const navDot1 = this.querySelector('.v5-scroll-pic-dot-1')
      const navDot2 = this.querySelector('.v5-scroll-pic-dot-2')
      const navList = this.querySelector('.v5-scroll-pic-nav ul')
      const contentWrap = this.querySelector('.v5-scroll-pic-content')
      const gsap = window.gsap
      const ScrollTrigger = window.ScrollTrigger
      const isLarge = window.matchMedia('(min-width: 1024px)').matches

      if (!gsap || !slide1 || !slide2) return

      // 初始状态：PC 端启用入场位移与透明度，MB 端不需要动效
      if (isLarge) {
        gsap.set(slide1, { opacity: 0.5, y: 140, willChange: 'transform, opacity' })
        gsap.set(slide2, { opacity: 0, y: -140, willChange: 'transform, opacity' })
      } else {
        gsap.set(slide1, { opacity: 1, y: 0 })
        gsap.set(slide2, { opacity: 1, y: 0 })
      }

      // 导航圆点高亮控制（MB 不需要动效，移除过渡，仅状态切换）
      const setActive = (idx) => {
        if (!navDot1 || !navDot2) return
        ;[navDot1, navDot2].forEach(d => {
          d.style.transition = isLarge ? 'box-shadow 0.2s ease, opacity 0.2s ease' : 'none'
          d.style.opacity = '0.4'
          // PC：段条较高时仅加粗，不改变高度；短元素保持原缩放逻辑
          // MB：不需要放大或变形，禁用 transform
          if (isLarge) {
            const isTall = d.offsetHeight > 12
            d.style.transform = isTall ? 'scaleX(1)' : 'scale(1)'
          } else {
            d.style.transform = 'none'
          }
        })
        const active = idx === 1 ? navDot1 : navDot2
        active.style.opacity = '1'
        if (isLarge) {
          const isTallActive = active.offsetHeight > 12
          active.style.boxShadow  = ' white 1px 1px 20px 1px'
        } else {
          active.style.transform = 'none'
        }
      }

      // 圆点点击跳转到对应区域
      navDot1 && navDot1.addEventListener('click', () => {
        slide1 && slide1.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
      navDot2 && navDot2.addEventListener('click', () => {
        slide2 && slide2.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })

      // 根据内容块高度与位置动态设置左侧导航段条
      const updateNavSegments = () => {
        if (!navList || !contentWrap || !navDot1 || !navDot2 || !slide1 || !slide2) return
        // 让导航列表顶部对齐容器（MB 已在模板中 top-0），这里确保一致
        navList.style.top = '0px'
        navList.style.transform = 'none'
        navList.style.height = `${contentWrap.offsetHeight}px`

        // 计算内容真实高度范围（标题/副标题/图片/描述）
        const getContentBounds = (slide, idx) => {
          const title = slide.querySelector(idx === 1 ? '.v5-scroll-title-1' : '.v5-scroll-title-2')
          const subtitle = slide.querySelector(idx === 1 ? '.v5-scroll-subtitle-1' : '.v5-scroll-subtitle-2')
          const text = slide.querySelector(idx === 1 ? '.v5-scroll-text-1' : '.v5-scroll-text-2')
          const imgs = Array.from(slide.querySelectorAll('img'))
          const candidates = [title, subtitle, text, ...imgs].filter(Boolean).filter(el => el.offsetParent !== null)
          if (!candidates.length) {
            return { top: slide.offsetTop, height: slide.offsetHeight }
          }
          const containerRect = contentWrap.getBoundingClientRect()
          let minTop = Infinity, maxBottom = -Infinity, lastEl = null
          candidates.forEach(el => {
            const r = el.getBoundingClientRect()
            if (r.top < minTop) minTop = r.top
            if (r.bottom > maxBottom) {
              maxBottom = r.bottom
              lastEl = el
            }
          })
          const top = Math.max(0, (minTop - containerRect.top))
          const mb = lastEl ? parseFloat(window.getComputedStyle(lastEl).marginBottom || '0') : 0
          const height = Math.max(0, (maxBottom - minTop + mb))
          return { top, height }
        }

        // 移动端：仅根据文本容器（.v5-scroll-pic-content-mb .content-top）来设置段条高度与顶部对齐
        const getMBTextBounds = (slide) => {
          const contentTop = slide.querySelector('.v5-scroll-pic-content-mb .content-top')
          if (!contentTop) return { top: slide.offsetTop, height: slide.offsetHeight }
          const containerRect = contentWrap.getBoundingClientRect()
          const r = contentTop.getBoundingClientRect()
          // 仅使用文本容器的盒模型高度（包含内边距，不包含外边距）
          const top = Math.max(0, r.top - containerRect.top)
          const height = Math.max(0, r.height)
          return { top, height }
        }

        const b1 = isLarge ? getContentBounds(slide1, 1) : getMBTextBounds(slide1)
        const b2 = isLarge ? getContentBounds(slide2, 2) : getMBTextBounds(slide2)
        Object.assign(navDot1.style, { position: 'absolute', top: `${b1.top}px`, height: `${b1.height}px` })
        Object.assign(navDot2.style, { position: 'absolute', top: `${b2.top}px`, height: `${b2.height}px` })
      }

      // 仅 PC 端启用动效：优先使用 ScrollTrigger（若已加载），否则降级为 IntersectionObserver
      if (isLarge && ScrollTrigger) {
        if (!window._scrollTriggerRegistered) {
          try { gsap.registerPlugin(ScrollTrigger) } catch (e) {}
          window._scrollTriggerRegistered = true
        }
        // 在页面与资源（图片等）加载完成后刷新触发器，避免位置计算不准
        const refreshST = () => { try { ScrollTrigger.refresh() } catch (e) {} }
        if (!this._refreshBound) {
          window.addEventListener('load', refreshST, { once: true })
          ;[...this.querySelectorAll('img')].forEach(img => {
            if (img.complete) return
            img.addEventListener('load', refreshST, { once: true })
          })
          this._refreshBound = true
        }

        // ScrollTrigger 刷新后也更新导航段条位置与高度
        ScrollTrigger.addEventListener('refresh', updateNavSegments)

        // 独立 fromTo 动画 + toggleActions：进入播放，离开反向；支持反复触发
        gsap.fromTo(
          slide1,
          { opacity: 0.5, y: 140 },
          {
            opacity: 1,
            y: 0,
            duration: 1.4,
            ease: 'power3.out',
            onUpdate: updateNavSegments,
            scrollTrigger: {
              trigger: slide1,
              start: 'top 65%',
              end: 'bottom 45%',
              toggleActions: 'play reverse play reverse'
              // markers: true
            }
          }
        )

        gsap.fromTo(
          slide2,
          { opacity: 0, y: -140 },
          {
            opacity: 1,
            y: 0,
            duration: 1.4,
            ease: 'power3.out',
            onUpdate: updateNavSegments,
            scrollTrigger: {
              trigger: slide2,
              start: 'top 65%',
              end: 'bottom 45%',
              toggleActions: 'play reverse play reverse'
              // markers: true
            }
          }
        )

        // 滚动高亮：进入对应区域时高亮圆点，离开时切换
        ScrollTrigger.create({
          trigger: slide1,
          start: 'top 65%',
          end: 'bottom 45%',
          onEnter: () => setActive(1),
          onEnterBack: () => setActive(1),
          onLeave: () => setActive(2),
          onLeaveBack: () => setActive(2)
        })
        ScrollTrigger.create({
          trigger: slide2,
          start: 'top 65%',
          end: 'bottom 45%',
          onEnter: () => setActive(2),
          onEnterBack: () => setActive(2),
          onLeave: () => setActive(1),
          onLeaveBack: () => setActive(1)
        })
      } else if (isLarge) {
        // 无 ScrollTrigger 时的降级：仅 PC 端使用 IntersectionObserver 触发一次性动画
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const el = entry.target
            // 进入视口：播放入场动画；离开视口：恢复到初始状态，支持再次触发
            if (entry.isIntersecting) {
              if (el === slide1) {
                gsap.to(slide1, { opacity: 1, y: 0, duration: 1.4, ease: 'power3.out', onUpdate: updateNavSegments })
                setActive(1)
              } else if (el === slide2) {
                gsap.to(slide2, { opacity: 1, y: 0, duration: 1.4, ease: 'power3.out', onUpdate: updateNavSegments })
                setActive(2)
              }
            } else {
              if (el === slide1) {
                gsap.to(slide1, { opacity: 0.5, y: 140, duration: 0.8, ease: 'power3.in', onUpdate: updateNavSegments })
              } else if (el === slide2) {
                gsap.to(slide2, { opacity: 0, y: -140, duration: 0.8, ease: 'power3.in', onUpdate: updateNavSegments })
              }
            }
          })
        }, { root: null, rootMargin: '0px 0px -25%', threshold: 0.25 })
        io.observe(slide1)
        io.observe(slide2)
      }

      // 初始高亮：默认第一个
      setActive(1)

      // 首次与窗口变化时更新导航段条位置与高度
      updateNavSegments()
      window.addEventListener('load', updateNavSegments, { once: true })
      ;[...this.querySelectorAll('img')].forEach(img => {
        if (img.complete) return
        img.addEventListener('load', updateNavSegments, { once: true })
      })
      window.addEventListener('resize', () => { updateNavSegments() })

      // 监听内容区域尺寸变化（字体/图片加载引起的布局变化）
      if (window.ResizeObserver) {
        try {
          const ro = new ResizeObserver(() => updateNavSegments())
          ro.observe(contentWrap)
          ro.observe(slide1)
          ro.observe(slide2)
          this._navRO = ro
        } catch (e) {}
      }
      // 字体加载完成后再校准一次
      if (document && document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => updateNavSegments()).catch(() => {})
      }
    }
  }
  customElements.define('jky-v5-scroll-pic-3', JkyV5ScrollPic3);
}
